const FRENTES = [
  {
    number: '01',
    title: 'Incentivo Comercial',
    description: 'Premie vendas, novos contratos, upgrades, cross-sell e metas comerciais de forma automática e auditável.',
    icon: 'ri-line-chart-line',
    iconBg: 'bg-primary-100 text-primary-700',
  },
  {
    number: '02',
    title: 'Incentivo a Corretores e Parceiros',
    description: 'Crie campanhas específicas para cada canal e perfil: corretor, gerente, assessoria e parceiro.',
    icon: 'ri-team-line',
    iconBg: 'bg-accent-100 text-accent-700',
  },
  {
    number: '03',
    title: 'Fidelização e Retenção',
    description: 'Estruture campanhas de relacionamento e permanência para reduzir churn e fortalecer a carteira.',
    icon: 'ri-heart-3-line',
    iconBg: 'bg-secondary-100 text-secondary-800',
  },
  {
    number: '04',
    title: 'Engajamento',
    description: 'Crie jornadas de participação e reconhecimento para beneficiários e empresas contratantes.',
    icon: 'ri-rocket-2-line',
    iconBg: 'bg-primary-100 text-primary-700',
  },
  {
    number: '05',
    title: 'Gamificação',
    description: 'Metas, rankings, desafios e campanhas em tempo real que mantêm o time focado até o último dia.',
    icon: 'ri-trophy-line',
    iconBg: 'bg-accent-100 text-accent-700',
  },
  {
    number: '06',
    title: 'Gestão e Auditoria',
    description: 'Rastreabilidade completa da origem de cada crédito, com regras claras e trilha de auditoria.',
    icon: 'ri-shield-check-line',
    iconBg: 'bg-secondary-100 text-secondary-800',
  },
];

export default function SaudeFrentes() {
  return (
    <section id="solucoes" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            Soluções
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Seis frentes para um ecossistema <span className="text-accent-600">inteiro de incentivo</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-600">
            Da venda à retenção, a GetPoints atua como uma infraestrutura tecnológica de incentivo para o mercado de saúde.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FRENTES.map((frente) => (
            <article
              key={frente.number}
              className="group flex flex-col rounded-3xl border border-background-200 bg-background-50 p-7 transition-colors hover:border-primary-200 md:p-8"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${frente.iconBg}`}>
                  <i className={`${frente.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-sm font-bold text-foreground-300">{frente.number}</span>
              </div>
              <h3 className="mt-6 font-heading text-xl font-bold text-foreground-950 md:text-2xl">{frente.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{frente.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}